import React from "react";

export const ContactForm = (props) => {
  return (
    <div>
      <div id="contact-form" >
      <div className="container contact-form-section">
        <div className="google-form">
          <h2 className="contact-form-title">Get Quote</h2>
          <iframe className="google-iframe" src="https://docs.google.com/forms/d/e/1FAIpQLScHjO369PMRNrweN1fhZA4TdAsKQA51AnBp0FY38RlJD0EM_g/viewform?embedded=true" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </div>
        <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 S S Transformers
          </p>
        </div>
      </div>
      </div>
    </div>
    </div>
  );
};
